/**
 * Synchronous cookie access, backed by document.cookie.
 *
 * Sync on purpose: the Cookie Store API is asynchronous, secure-context only,
 * and missing before Safari 18.4 / Firefox 138, and the callers here want a
 * value now (the boot-time login check, request headers), not a pending
 * promise. HttpOnly cookies aren't exposed to scripts, so those read as absent.
 */
export const Cookies = {
  /**
   * Returns a cookie's value (a string, possibly empty), or `null` when the
   * cookie is absent.
   * @param name - the cookie name to read
   */
  get(name: string): string | null {
    const prefix = `${name}=`;
    const match = document.cookie.split(/;\s*/).find((cookie) => cookie.startsWith(prefix));

    return match ? decodeURIComponent(match.slice(prefix.length)) : null;
  },

  /**
   * Whether a cookie is present, whatever its value (an empty value still
   * counts as present).
   * @param name - the cookie name to check
   */
  has(name: string): boolean {
    return Cookies.get(name) !== null;
  },

  /**
   * Writes a cookie at the domain root for the current session.
   * @param name - the cookie name to write
   * @param value - the value to write; url-encoded, so `get` returns it verbatim
   */
  set(name: string, value: string): void {
    document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=/`;
  },
};
